"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.myPropertyReducer = void 0;
var MyPropertyAction_1 = require("@/pages/myproperty/actions/MyPropertyAction");
var typesafe_actions_1 = require("typesafe-actions");
exports.myPropertyReducer = function (defaultState) {
    return function (state, action) {
        if (state === void 0) { state = defaultState; }
        switch (action.type) {
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onCardClicked): {
                var index_1 = action.payload;
                return __assign(__assign({}, state), { eformProperties: state.eformProperties.map(function (it, i) {
                        if (i !== index_1)
                            return it;
                        return __assign(__assign({}, it), { isExpanded: !it.isExpanded });
                    }) });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onEformExpandClicked): {
                var _a = action.payload, index_2 = _a.index, eformIndex_1 = _a.eformIndex;
                return __assign(__assign({}, state), { eformProperties: state.eformProperties.map(function (it, i) {
                        if (i !== index_2)
                            return it;
                        return __assign(__assign({}, it), { eforms: it.eforms.map(function (it2, j) {
                                if (j !== eformIndex_1)
                                    return it2;
                                return __assign(__assign({}, it2), { isExpanded: !it2.isExpanded });
                            }) });
                    }) });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setResult): {
                var _b = action.payload, eformProperties = _b.eformProperties, currentPage = _b.currentPage, totalPage = _b.totalPage, totalItems = _b.totalItems;
                return __assign(__assign({}, state), { eformProperties: eformProperties,
                    currentPage: currentPage,
                    totalItems: totalItems,
                    totalPage: totalPage, isLoading: false });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onSearchKeywordChanged): {
                var keyword = action.payload;
                return __assign(__assign({}, state), { keyword: keyword });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setSearchKeyword): {
                var keyword = action.payload;
                return __assign(__assign({}, state), { keyword: keyword });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setReportSoldPropertyIndex): {
                return __assign(__assign({}, state), { reportSoldPropertySelectedIndex: action.payload, reportSoldActive: true });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onReportSoldClose): {
                return __assign(__assign({}, state), { reportSoldPropertySelectedIndex: -1, reportSoldActive: false });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onSoldPriceChanged): {
                return __assign(__assign({}, state), { reportSoldSoldPrice: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onLeasePriceChanged): {
                return __assign(__assign({}, state), { reportSoldLeasePrice: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onSoldAgencyChanged): {
                return __assign(__assign({}, state), { reportSoldAgency: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onSoldDateChanged): {
                return __assign(__assign({}, state), { reportSoldSoldDate: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setReportSoldLoading): {
                return __assign(__assign({}, state), { reportSoldIsLoading: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setReportSoldDisableIndex): {
                var index_3 = action.payload;
                return __assign(__assign({}, state), { eformProperties: state.eformProperties.map(function (it, i) {
                        if (i !== index_3)
                            return it;
                        return __assign(__assign({}, it), { isDisabled: true });
                    }) });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setReportSoldHidden): {
                return __assign(__assign({}, state), { reportSoldPropertySelectedIndex: -1, reportSoldActive: false });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setDocumentOnPropertyCard): {
                var _c = action.payload, index_4 = _c.index, eforms_1 = _c.eforms;
                return __assign(__assign({}, state), { eformProperties: state.eformProperties.map(function (it, i) {
                        if (i !== index_4)
                            return it;
                        return __assign(__assign({}, it), { eforms: eforms_1, isLoading: false });
                    }) });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setSuggestions): {
                return __assign(__assign({}, state), { suggestions: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setSuggestionsActive): {
                return __assign(__assign({}, state), { suggestionActive: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.setSuggestionIndex): {
                return __assign(__assign({}, state), { currentSuggestionIndex: action.payload });
            }
            case typesafe_actions_1.getType(MyPropertyAction_1.default.onSoldDateFocus): {
                return __assign(__assign({}, state), { isReportSoldDateFocused: true });
            }
            default:
                return state;
        }
    };
};
